/* istanbul ignore file */
import OverlayView from './OverlayView'
import styles from './Cluster.module.scss'

export type TProps = {
  map?: google.maps.Map
  onClick: (map: google.maps.Map) => void
  location: {
    lat: number
    lng: number
  }
  count: number
}

const Cluster = ({ map, onClick, location, count }: TProps) => {
  if (map) {
    return (
      <OverlayView position={location} map={map} zIndex={count}>
        <button
          type="button"
          onClick={() => onClick(map)}
          className={styles.ecMapCluster}
          title={`${count} imóveis próximos`}
        >
          {count}
        </button>
      </OverlayView>
    )
  }

  return null
}

export default Cluster
